<template>
    <div class="px-5 bg-lightest mb-4 pb-4">
        <div class="px-5">
            <div class="dark fs-super pt-4 pb-3">{{niceDate(group.date)}}</div>
            
            <table class="w-100">
                <tr class="bg-lighter dark bold">
                    <th class="startHourWidth">Departure</th>
                    <th>Resource</th>
                    <th>Duration</th>
                    <th class="text-center">Prices</th>
                    <th class="text-center">Available/total</th>
                    <th style="width: 30%"></th>
                </tr>
                <tr class="fs-large" v-for="event in group.events" :key="event.id">
                    <td class="fs-larger">{{ startHour(event.start) }}</td>
                    <td class="slightlySmallerText">{{ resources(event) }}</td>
                    <td class="slightlySmallerText">{{ hourToDuration(event.duration) }}</td>
                    <td class="slightlySmallerText text-center relative" >
                        <div class="mt-2">
                            <span>{{ event.eventGenderPrices[0].audienceTypeDescription}}</span>
                            <span>{{ formatPrice(event.eventGenderPrices[0].grossprice)}} €</span>
                        </div>
                        <div @click.stop="toogleBox(event.id)" v-click-outside="closeBox">
                            <div type="button" class="fs-smaller fa fa-info-circle medium ml-1 p-2"></div>
                            <div class="floating-menu left centered d-flex flex-column" v-if="showBox[event.id]">
                                <ul v-for="price in showPrices(event)" :key="price.id">
                                    <li class="normal">{{ price }}</li>
                                </ul>
                            </div>
                        </div>
                    </td>
                    <td class="text-center">
                        <div class="fs-largest"><b>{{event.quantityAvailable}}</b>/{{event.maximumLotation}} </div>
                        <div class="fs-smaller">{{event.maximumLotation - event.quantityAvailable}} booked</div>
                    </td>
                    <td :class="{'d-flex': isAdmin && rejectBookingBasedOnMinMax(event) && (!isMinLimitsSatisfied(event) || !isMaxLimitsSatisfied(event)),'text-center': true}" v-if="$route.meta.reschedule">
                        <div v-if="isAdmin && rejectBookingBasedOnMinMax(event)" class="d-flex align-items-center ml-5">
                            <i v-if="!isMinLimitsSatisfied(event)" v-tooltip="minLimitsMessage(event)" class="ico-alert color-6 fs-largest"></i>
                            <i v-if="!isMaxLimitsSatisfied(event)" v-tooltip="maxLimitsMessage(event)" class="ico-alert color-6 fs-largest"></i>
                        </div>

                        <button 
                            :class="{'btn widest bg-color-2 border-color-2 fs-large my-2': true ,'ml-5': isAdmin && rejectBookingBasedOnMinMax(event) && (!isMinLimitsSatisfied(event) || !isMaxLimitsSatisfied(event))}"
                            :disabled="getIsRescheduling"
                            v-if="isAdmin || !(rejectBookingBasedOnMinMax(event) && !isMinLimitsSatisfied(event)) && !(rejectBookingBasedOnMinMax(event) && !isMaxLimitsSatisfied(event)) && canISellThisEvent(event).allowed" 
                            @click="reschedulePrompt(event)">{{selectedEvent && selectedEvent.id == event.id && getIsRescheduling ? 'REBOOKING':'REBOOK'}}
                        </button>

                        <button v-if="!canISellThisEvent(event).allowed && !isAdmin" class="btn widest bg-dark fs-large my-2" @click="showChannelClosedPopup(event)">CLOSED</button>
                        
                        <div v-else-if="rejectBookingBasedOnMinMax(event) && !isMinLimitsSatisfied(event)">
                            <AlertMessage 
                                :message="minLimitsMessage(event)" 
                                icon="ico-alert" bold />
                        </div>

                        <div v-else-if="rejectBookingBasedOnMinMax(event) && !isMaxLimitsSatisfied(event)">
                            <AlertMessage 
                                :message="maxLimitsMessage(event)" 
                                icon="ico-alert" bold />
                        </div>
                    </td>
                    <td class="text-center" v-if="!$route.meta.reschedule">
                        <button v-if="event.status == -1" class="btn widest border-color-6 bg-color-6 lightest fs-large my-2" @click="showCanceledPopup(event)">EVENT CANCELED</button>
                        <button v-if="!canISellThisEvent(event).allowed && !isAdmin" class="btn widest bg-dark fs-large my-2 btn-size" @click="showChannelClosedPopup(event)">CLOSED</button>
                        <button v-else class="btn widest border-color-3 fs-large my-2 btn-size" @click="book(event)">BOOK</button>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {eventMixin} from '@/mixins/event';
import AlertMessage from '@/tools/alertMessage/AlertMessage';

export default {
    mixins:[ eventMixin ],
    data(){
        return {
            selectedEvent: null,
            showBox:{},
        }
    },
    props: {
        group: {
            type: Object,
            default: {}
        },
        reservationDetails: {
            type: Object,
            default: {}
        }
    },
    computed: {
        ...mapGetters([
            'account',
            'getIsRescheduling',
            'getClonedReservation'
        ]),
        isAdmin() {
            return this.reservationDetails.accessType === 1;
        }
    },
    methods: {
        ...mapActions([
            'setReservationSelectedEvent',
            'setNewEventRebook',
            'rescheduleExistingReservation',
            'addFloatingNotification',
            'checkPricesForRebook',
            'openModal',
            'clearClonedReservation'
        ]),
        isMaxLimitsSatisfied(event) {
            if (event.maximumPaxPerBooking === 0) {
                return true;
            } else {
                return this.reservationDetails.totalPaxReservation <= event.maximumPaxPerBooking;
            }
        },
        isMinLimitsSatisfied(event) {
            if (event.minimumPaxPerBooking === 0) {
                return true;
            } else {
                return this.reservationDetails.totalPaxReservation >= event.minimumPaxPerBooking;
            }
        },
        rejectBookingBasedOnMinMax(event) {
            return event.rejectBookingBasedOnMinMax;
        },
        minLimitsMessage(event) {
			return `Below minimum people required per booking (${event.minimumPaxPerBooking} PAX) for this reservation.`;
		},
		maxLimitsMessage(event) {
			return `Exceeds maximum people allowed per booking (${event.maximumPaxPerBooking} PAX) for this reservation.`;
		},
        niceDate(stringDate) {
            return moment(stringDate).format('DD MMMM YYYY');
        },
        toogleBox(eventId) {
            // Toggle the box visibility for the clicked event
            this.$set(this.showBox, eventId, !this.showBox[eventId]);
        },
        closeBox() {
            this.showBox = {};
        },
        showPrices(event) {
            let prices = event.eventGenderPrices.map(e => {
                return `${e.audienceTypeDescription ? e.audienceTypeDescription : 'Tickets'} : ${this.formatPrice(e.grossprice)} €`;
            })

            return prices;
        },
        startHour(startHourString) {
            return this.formatTime(startHourString);
        },
        resources(event) {
            let resourcesNames = [];

            for (let resource of event.eventResources) {
                resourcesNames.push(resource.name);
            }

            let resourcesString = resourcesNames.join(', ');

            return resourcesString;
        },
        book(event) {
            this.setReservationSelectedEvent(event);
            this.$router.push('/reservation/resume');
        },
        reschedulePrompt(event) {
            // With this we can now if this particular event is being rescheduled so that we can show the "rescheduling" button only on this event
            this.selectedEvent = event;
            let vm = this;

            this.checkPricesForRebook({
                bookingId: this.getClonedReservation.id,
                newEventId: event.id
            }).then(response => {
                if (response.data.isEqual) {
                    this.$dialog.confirm('Are you sure you want to rebook to '+ moment(event.start).format("DD-MM-YYYY HH:mm") + '?')
                    .then(() => {
                        if (vm.getClonedReservation.hasTransport) {
                            vm.$dialog.alert('The current booking has pickup/drop off, this will also rescheduled to '+ moment(event.start).format("DD-MM-YYYY") + ', to change it you should edit the reservation after the rebook.', {okText: 'OK'})
                            .then(() => {
                                vm.registerReschedule(event);
                            })
                            .catch(() => {});
                        } else {
                            vm.registerReschedule(event);
                        }})
                    .catch(() => {});
                } else {
                    this.setNewEventRebook({ event: event, 
                                             isMaxLimitsSatisfied: this.isMaxLimitsSatisfied(event), 
                                             isMinLimitsSatisfied: this.isMinLimitsSatisfied(event),
                                             rejectBookingBasedOnMinMax: this.rejectBookingBasedOnMinMax(event),
                                           })
                    this.openModal('CompareEventsRebook')
                }
                })
            .catch(() => {});
        },
        registerReschedule(event) {
            this.rescheduleExistingReservation({
                supplierId: this.account.supplierId,
                deliverNotification: false,
                event: event,
                booking: this.getClonedReservation,
                isToUpdateGenderPrices: false
            }).then(response => {
                this.addFloatingNotification(
                    {
                        type: -1,
                        title: 'Ticket '+this.formatTicketNumber(response.data.id),
                        message: response.data.customer.name+' <br>'+response.data.event.product.name,
                        bookingId: response.data.id,
                    },
                    'info',
                    {
                        link: '/reservations/view/'+response.data.id
                    }
                )
                
                this.clearClonedReservation();
                this.$router.push('/reservations');
            })
        },
        showCanceledPopup(event) {
            this.$dialog.alert(
                'The event "'+event.product.name+'" has been canceled.<br>' + (event.statusMessage? 'Cancel message: '+event.statusMessage : ''),
                {okText: 'OK'}
            );
        },
        showChannelClosedPopup(event) {
            this.$dialog.alert(
                'The sales channel for this event has been closed.<br>', 
                {okText: 'OK'}
            );
        }
    },
    components: {
		AlertMessage
    }
}
</script>
<style lang="scss" scoped>
    @import '../../../../assets/scss/_variables.scss';

    table {
        tr {
            th {
                font-size: $font-size-small;
                font-weight: 600;
                padding: 0.5rem 1rem;
            }
            td { 
                padding: 0 1rem;
            }
        }
    }

    .slightlySmallerText {
        font-size: 0.9rem;
    }

    .floating-menu {
        padding: 3px;
        border: 1px solid #8ca0b324;
    }

    .startHourWidth {
        width: 12%;
    }
    
    .notesWidth {
        width: 30%;
    }

    .btn-size {
        width: 130px;
        height: 39px;
    }
</style>



// WEBPACK FOOTER //
// SingleDay.vue?f15ea10c